import type { Addon, Item } from "../api/menu";

// Добавките на продукт така, както ги вижда сервитьорът в „Промени“ — общо за
// модала „Промени“ (useAddonSelection), редактора на дневното меню (порциите на
// добавките) и броенето на порциите в „Маркиране“. BE праща само активните.

// Подредба на групите: задължителни → без тип → препоръчителни → по избор
export const addonSortOrder = (addon: Addon): number => {
  if (addon.type === 2) return 0;
  if (addon.type === 3) return 2;
  if (addon.type === 1) return 3;
  return 1;
};

/** Добавките на продукта, подредени като в „Промени“. */
export const productAddonsOf = (item: Pick<Item, "addonIds">, allAddons: Addon[]): Addon[] =>
  allAddons
    .filter((addon) => item.addonIds.includes(addon.id))
    .sort((first, second) => addonSortOrder(first) - addonSortOrder(second));

/** Опциите на добавката, които реално са в каталога (останалите не се показват). */
export const addonOptionIdsInCatalog = (addon: Addon, catalogIds: ReadonlySet<number>): number[] =>
  addon.items.map((option) => option.itemId).filter((itemId) => catalogIds.has(itemId));

/** Уникалните опции (продукти) на всички добавки на продукта, в реда на „Промени“. */
export const addonOptionIdsOf = (
  item: Pick<Item, "addonIds">,
  allAddons: Addon[],
  catalogIds: ReadonlySet<number>,
): number[] => [
  ...new Set(
    productAddonsOf(item, allAddons).flatMap((addon) => addonOptionIdsInCatalog(addon, catalogIds)),
  ),
];
